export default function ChevronRight() {
    return (
        <svg>
            <use xlinkHref="#chevron-right" />
        </svg>
    );
}
